<template>
    <div v-if="loading" class="center__page">
      <i class="el-icon-loading" style="font-size: 40px;"></i>
    </div>
    <div v-else-if="error" class="center__page" style="flex-direction: column;">
      <h2>Document Not Available</h2>
      <p>The document you are trying to access may be missing or temporarily unavailable.</p>
      <base-button @click="retry">Try Again</base-button>
    </div>
    <div v-else v-html="htmlContent"></div>
  </template>
  
  <script>
  export default {
    props: {
      path: {
        type: String,
        required: true,
      },
      templateVars: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        htmlContent: '',
        rawHtmlTemplate: '',
        loading: true,
        error: false,
        localTemplateVars: { ...this.templateVars },
      };
    },
    mounted() {
      this.loadAndReplaceTemplate(this.path);
    },
    methods: {
      async loadAndReplaceTemplate(path) {
        this.htmlContent = '';
        this.rawHtmlTemplate = '';
        this.error = false;
        this.loading = true;
        try {
          const htmlRaw = await this.$store.dispatch('getDocumentAgreementFile', {
            name: path,
          });

          let cleanedHtml = htmlRaw.data
            .replace(/–/g, '-')
            .replace(/\uFFFD/g, '')
            .replace(/(:\s*)yellow/gi, '')
            .replace(/<table[\s\S]*?<\/table>/gi, '')
            .replace(/EXHIBIT A/gi, '')
            .replace(/<del[^>]*>[\s\S]*?<\/del>/gi, '')
            .replace(/<ins[^>]*>/gi, '<span>')
            .replace(/<\/ins>/gi, '</span>')
            .replace(/<span class="msoIns">/gi, '<span>')
            .replace(/<\/span>/gi, '</span>');

          this.rawHtmlTemplate = cleanedHtml;
          this.replaceTemplateVars();
        } catch (err) {
          console.error('Failed load template:', err);
          this.error = true;
        } finally {
          this.loading = false;
        }
      },
      async replaceTemplateVars() {
        if (!this.rawHtmlTemplate) return;

        let html = this.rawHtmlTemplate.replace(/\{([\s\S]*?)\}/g, (match, key) => {
          const cleanedKey = key
            .replace(/<[^>]+>/g, '')
            .replace(/\s+/g, ' ')
            .trim();
          const value = this.localTemplateVars[cleanedKey];
          return value !== undefined && value !== null ? value : match;

          // return this.localTemplateVars[cleanedKey] || match;
        });

        // adendum c
        if(['minimum_spend', 'minimum_spend_v2', 'minimum_spend_v3'].includes(this.path) && ['userdownline', 'user'].includes(this.$store.getters.userData.user_type) && this.$global.idsys == this.$global.masteridsys) {
          try {
            const response = await this.$store.dispatch('getMinimumSpendUser', {
              company_id: this.$store.getters.userData.company_id
            })

            const months = typeof(response.months) != 'undefined' ? response.months : [];
            const flatMonth = typeof(response.flatMonth) != 'undefined' ? response.flatMonth : '';

            let tableRows = '';
            months.forEach((e, i) => {
              const month = i + 1;
              const value = e;
              tableRows += `<tr><td style='padding: 8px; border: 1px solid #ddd; text-align: left;'>Month ${month}</td><td style='padding: 8px; border: 1px solid #ddd; text-align: right;'>$${value}</td></tr>`;
            });
            
            let finalSentence = `<p style='margin-top: 15px; font-family: Arial, sans-serif; font-size: 11pt;'>Customer agrees to spend a minimum $${flatMonth} per month thereafter until service is terminated.</p>`;
            let finalHtmlBlock = `
              <div style='margin-top: 20px; padding-top: 20px; font-family: Arial, sans-serif; font-size: 11pt; color: #333; page-break-before: always;'>
                <h3 style='text-align: center; font-weight: bold; margin-right: 5rem;'>ADDENDUM C</h3>
                <h4 style='text-align: center; font-weight: bold; margin-bottom: 20px; margin-right: 7rem;'>Minimum Purchase Agreement</h4>
                <table style='width: 60%; margin: 20px auto; border-collapse: collapse; border: 1px solid #ddd; font-size: 11pt;'>
                  <thead style='background-color: #f2f2f2;'>
                    <tr>
                      <th style='padding: 8px; border: 1px solid #ddd; text-align: left;'>Month</th>
                      <th style='padding: 8px; border: 1px solid #ddd; text-align: right;'>Minimum Spend (USD)</th>
                    </tr>
                  </thead>
                  <tbody>${tableRows}</tbody>
                </table>
                ${finalSentence}
              </div>
            `;

            html = html.replace(/<\/body>/i, finalHtmlBlock + '</body>');
          } catch (err) {
            console.error(`Failed get minimum spend users : ${err}`);
          }
        }
        // adendum c

        // Hide Attention section if Token Attention is empty
        const tokenAttention = this.localTemplateVars['Token Attention'];
        if (!tokenAttention || (typeof tokenAttention === 'string' && tokenAttention.trim() === '')) {
          // After variable replacement, remove HTML elements containing "Attention:" with empty value
          // This regex matches patterns like: <p>Attention: </p>, <p>Attention:</p>, etc.
          // It handles cases where Attention: is followed by only whitespace, empty tags, or line breaks
          html = html.replace(/<p[^>]*>\s*Attention\s*:\s*(?:\s|&nbsp;|<br\s*\/?>|<\/?[^>]+>)*\s*<\/p>/gi, '');
          html = html.replace(/<div[^>]*>\s*Attention\s*:\s*(?:\s|&nbsp;|<br\s*\/?>|<\/?[^>]+>)*\s*<\/div>/gi, '');
          // Also handle cases where Attention: appears on its own line within a larger block
          html = html.replace(/(<[^>]+>\s*)?Attention\s*:\s*(?:\s|&nbsp;|<br\s*\/?>|<\/?[^>]+>)*\s*(<\/[^>]+>)?/gi, (match) => {
            // Remove HTML tags and check if there's any actual content after "Attention:"
            const contentAfter = match.replace(/Attention\s*:\s*/i, '').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/<br\s*\/?>/gi, '').trim();
            return contentAfter === '' ? '' : match;
          });
        }

        this.htmlContent = html;
      },
      retry() {
        this.loadAndReplaceTemplate(this.path);
      },
    },
    watch: {
      templateVars: {
        handler(newValue){
            this.localTemplateVars = { ...newValue };
            this.replaceTemplateVars();
        },
        deep: true,
        immediate: true,
      }
    }
  };
  </script>
  
<style>
.center__page {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
}

span.msoIns {
  color: black !important;
  text-decoration: none !important;
}
</style>
  